var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQlTakeTimeTalks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.772,
    height: 38,
    viewBox: "0 0 52.772 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.009 20.557a10.51 10.51 0 0 0 4.17-8.338C24.179 5.474 17.551 0 9.325 0A22.447 22.447 0 0 0 0 2.42c1.536.995 4.713 3.553 4.713 3.553a15.436 15.436 0 0 1 2.478 2.893 11.6 11.6 0 0 1 2 5.934c.018.345-.07 1.139-.07 1.557a13.75 13.75 0 0 1-1.25 3.368c-.117.11-1.024 1.619-1.255 1.83-.125.115-.24.446-.47.643-.443.382-.971 1.044-1.6 1.521a8.257 8.257 0 0 0-2.018 1.625c.207.019 6.483 5.982 7.754 5.815.455-.06-.118-.981-.2-1.795-.175-1.812.983-5.194 1.222-5.194 1.226 0 8.7-3.615 8.7-3.615z",
    transform: "translate(-911 -282.539) rotate(-15 1562.991 -3396.556)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.151 12C16.231 12 9 17.549 9 24.395c0 3.6 2.005 6.844 5.2 9.108-1.613 2.8-1.86 5.28-5.111 6.933h2.6a14.67 14.67 0 0 0 6.154-1.847c1.329-.6 1.368-.647 3.047-2.234a20.794 20.794 0 0 0 4.261.434c8.92 0 16.151-5.549 16.151-12.395S34.071 12 25.151 12z",
    transform: "translate(-911 -282.539) translate(902 280.102)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQlTakeTimeTalks);
export default __webpack_public_path__ + "static/media/ql-take-time-talks.ace805eab60194cf037b3247ec8410ff.svg";
export { ForwardRef as ReactComponent };